import { Component, OnInit, ViewChild, ElementRef, Input, Output, EventEmitter } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { ConfirmationService, Message } from 'primeng/api';
import { ErroService } from 'src/app/admihair/service/erro.service';
import { Empresa } from 'src/app/admihair/api/dto/empresa';
import { NgForm } from '@angular/forms';
import { Usuario } from 'src/app/admihair/api/dto/usuario';
import { UsuarioService } from 'src/app/admihair/service/usuario.service';
import { Administradora } from 'src/app/admihair/api/dto/administradora';
import { AdministradoraService } from 'src/app/admihair/service/administradora.service';
import { EmpresaService } from 'src/app/admihair/service/empresa.service';
import { PlanoContaEmpresaService } from 'src/app/admihair/service/plano-conta-empresa.service';
import { PlanoContaEmpresa } from 'src/app/admihair/api/dto/plano-conta-empresa.';


@Component({
  selector: 'app-plano-conta-empresa-detalhar',
  templateUrl: './plano-contas-empresa-detalhar.component.html',
  styleUrls: ['./plano-contas-empresa-detalhar.component.scss']
})
export class PlanoContaEmpresaDetalharComponent implements OnInit {


  @Input() id?: number;
  @Output() emissor = new EventEmitter();
  messages: Message[] = [{ severity: 'success', summary: 'Sucesso', detail: 'Cliente salvo' }];
  messagemVisivel: boolean = false;
  planoContaEmpresa?: PlanoContaEmpresa;

  
  constructor(private planoContaEmpresaService: PlanoContaEmpresaService,
    private erroService: ErroService,
    private empresaService: EmpresaService,
    private administradoraService: AdministradoraService,
    private _router: Router,
    private _activatedRoute: ActivatedRoute) { }

  ngOnInit(): void {
    this.carregarPlanoContaEmpresa();
  }

  carregarPlanoContaEmpresa(){
    this.planoContaEmpresaService.buscarPorId(this.id).subscribe({
      next: (data: PlanoContaEmpresa) => {
        this.planoContaEmpresa = data;
        console.log(data);
      }
    })
  }

  voltar(){
    this.emissor.emit({modo: 'LISTAR'});
  }


  navigateToFirstChild() {
    this._router.navigate(["/auth/login"], { relativeTo: this._activatedRoute })
  }

  editarIndicadorCliente(id: number){
    this._router.navigate(["/apps/indicador-cliente/editar/" + id], { relativeTo: this._activatedRoute })
  }


}
